import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common";
import { FLOATING_PLUGIN_TOOLBAR } from "./../toolbars-v3";
import { verticalEmbedModals } from "./constants";
import { InsertModal } from "./modals/InsertModal";
const getToolbarButtons = (config, services) => {
  const { modals } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      attributes: {
        active: {
          id: "IS_VERTICAL_EMBED_REPLACE_BUTTON_ACTIVE",
          resolve: (_, { modals: modals2 }) => Boolean(modals2.getModal(verticalEmbedModals.replace))
        }
      },
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        modals?.togglePluginPanel({
          id: verticalEmbedModals.replace,
          Component: InsertModal,
          componentProps: {
            modalId: verticalEmbedModals.replace,
            verticalsApi: config?.verticalsApi,
            componentData: { type: selectedNode.attrs.type },
            nodeId: selectedNode.attrs.id
          },
          isMobile,
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          focusReturnElement: referenceElement
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
